const defaultModifier = (x) => { return x }

const createInputHandler = (onChange, modifier = defaultModifier) => {
    return (newValue, event) => {
        return onChange(modifier(newValue), event)
    }
}

export default createInputHandler
